import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { diffInDay, isSameDay, parseDate } from '@jd/jmtd-tools/es/date';
import React from 'react';
import { getLocale } from '../locale';
import { dateSelectedState, formatDay } from '../tools/date';
import TitleTooltip from '../TitleTooltip';
import DoubleCalendar from '../DatePicker/DoubleCalendar';
import { getValue } from '../tools/util';
var RangePanel = {
  type: 'range',
  dateType: 'day',
  label: function label() {
    return getLocale(this.locale).datePicker.picker.range.label;
  },
  echo: function echo(x) {
    return getLocale(this.locale).datePicker.picker.range.echo(x);
  },
  render: function render(_ref) {
    var value = _ref.value,
        state = _ref.state,
        update = _ref.update,
        open = _ref.open,
        _ref$config = _ref.config,
        _ref$config$fixStart = _ref$config.fixStart,
        fixStart = _ref$config$fixStart === void 0 ? null : _ref$config$fixStart,
        _ref$config$isDateDis = _ref$config.isDateDisabled,
        _isDateDisabled = _ref$config$isDateDis === void 0 ? function () {
      return false;
    } : _ref$config$isDateDis,
        _ref$config$isValueDi = _ref$config.isValueDisabled,
        isValueDisabled = _ref$config$isValueDi === void 0 ? function () {
      return false;
    } : _ref$config$isValueDi,
        defaultPickerValue = _ref$config.defaultPickerValue,
        maxRange = _ref$config.maxRange,
        minRange = _ref$config.minRange,
        showWeekNumber = _ref$config.showWeekNumber,
        firstDayOfWeek = _ref$config.firstDayOfWeek,
        singlePanel = _ref$config.singlePanel,
        pickerConfig = _ref$config.pickerConfig,
        _ref$config$updateImm = _ref$config.updateImmediately,
        updateImmediately = _ref$config$updateImm === void 0 ? false : _ref$config$updateImm,
        locale = _ref.locale;

    // 固定起始日
    if (fixStart) {
      fixStart = getValue(fixStart, state);
      state.firstDate = fixStart;
    }

    var firstDate = state.firstDate,
        secondDate = state.secondDate;
    var selectedDate = value && value[0] && value.map(function (d) {
      return parseDate(d);
    }); // 选中的日期

    if (!selectedDate && !value) {
      selectedDate = [fixStart, fixStart];
    }

    return DoubleCalendar({
      open: open,
      value: value,
      className: 'jmtd-date-picker-range-panel',
      singlePanel: singlePanel,
      update: update,
      state: state,
      selectedDate: selectedDate,
      firstDayOfWeek: firstDayOfWeek,
      showWeekNumber: showWeekNumber,
      defaultPickerValue: defaultPickerValue,
      pickerConfig: pickerConfig,
      isDateDisabled: function isDateDisabled(dateItem) {
        if (_isDateDisabled(dateItem, {
          firstDate: firstDate
        }) || isValueDisabled(formatDay(dateItem, {
          firstDate: firstDate
        }))) {
          return true;
        }

        if (firstDate) {
          // 判断是否超出range
          var diffDays = Math.abs(diffInDay(dateItem, firstDate)) + 1;

          if (maxRange && diffDays > maxRange) {
            return true;
          }

          if (minRange && diffDays < minRange) {
            return true;
          }
        }

        return false;
      },
      render: function render(dateItem, _ref2) {
        var disabled = _ref2.disabled,
            content = _ref2.content;
        var result = {
          stateClass: _objectSpread(_objectSpread({}, (!fixStart ? firstDate : secondDate) ? dateSelectedState(dateItem, [firstDate, secondDate || firstDate]) : dateSelectedState(dateItem, selectedDate)), {}, {
            'jmtd-date-picker-cell-second': secondDate && isSameDay(secondDate, dateItem) && !isSameDay(firstDate, dateItem)
          }),
          onClick: function onClick() {
            if (!firstDate) {
              state.firstDate = dateItem;

              if (updateImmediately) {
                var d = formatDay(dateItem);
                update([d, d]);
              } else {
                update();
              }
            } else {
              delete state.firstDate;
              delete state.secondDate;
              update([firstDate, dateItem].sort(function (l, r) {
                return l - r;
              }).map(formatDay));
            }
          },
          onMouseEnter: function onMouseEnter() {
            if (!disabled && state.firstDate) {
              state.secondDate = dateItem;
              update();
            }
          },
          onMouseLeave: function onMouseLeave() {
            delete state.secondDate;
            update();
          }
        };

        if (!disabled && firstDate) {
          var diff = Math.abs(diffInDay(dateItem, firstDate)) + 1;
          Object.assign(result, {
            'data-event-content': diff,
            content: /*#__PURE__*/React.createElement(TitleTooltip, {
              className: "jmtd-date-picker-tooltip",
              mouseLeaveDelay: 0,
              title: getLocale(locale).datePicker.picker.range.rangeEcho(diff)
            }, content)
          });
        }

        return result;
      }
    });
  }
};
export default RangePanel;